import { render, staticRenderFns } from "./mmcgdmd.vue?vue&type=template&id=445655b4&scoped=true"
import script from "./mmcgdmd.vue?vue&type=script&lang=js"
export * from "./mmcgdmd.vue?vue&type=script&lang=js"
import style0 from "./mmcgdmd.vue?vue&type=style&index=0&id=445655b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445655b4",
  null
  
)

export default component.exports